import createNav from './skeletonNav.js';
import createDoc from './skeletonDoc.js';


export default () => 
    $(document.createDocumentFragment())
    .append(createNav)
    .append(createDoc);
